/** 0 = false, 1 = true */
export enum BOOLEAN_NUMBER {
  FALSE = 0,
  TRUE = 1
}
